"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appointmentHandlers = exports.cancelAppointmentRequest = exports.createAppointmentRequest = exports.getAppointmentQuestions = exports.getAppointmentDates = exports.getAvailableAppointmentCampaignsByDate = exports.getAppointmentCampaigns = exports.getAppointments = void 0;
var instance_1 = require("./instance");
var msw_1 = require("msw");
var mock = {};
function getAppointments(patientId) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Appointment",
        method: "GET",
        params: {
            patientId: patientId,
        },
    })
        .then(function (result) { return result.data; });
}
exports.getAppointments = getAppointments;
mock.getAppointments = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Appointment"), function (req, res, ctx) {
        return res(ctx.delay(1000), ctx.status(200), ctx.json([
            {
                appointmentId: "10",
                scheduledDateTime: "2024-03-18T15:00:00",
                campaignName: "Covid-19",
                campaignDescription: null,
                optionName: "Vaccination",
                addToVisit: true,
            },
            {
                appointmentId: "11",
                scheduledDateTime: "2024-04-20T12:00:00",
                campaignName: null,
                campaignDescription: null,
                optionName: null,
                addToVisit: false,
            },
            {
                appointmentId: "12",
                scheduledDateTime: "2024-05-30T13:30:00",
                campaignName: "Influenza",
                campaignDescription: "Protect yourself from the flu",
                optionName: "Vaccination",
                addToVisit: true,
            },
        ]));
    });
};
function getAppointmentCampaigns(pharmacyId) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Appointment/Campaigns",
        method: "GET",
        params: { pharmacyId: pharmacyId },
    })
        .then(function (response) {
        return response.data.filter(function (c) {
            return c.appointmentSettingType !== "Obsolete";
        });
    });
}
exports.getAppointmentCampaigns = getAppointmentCampaigns;
mock.getAppointmentCampaigns = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Appointment/Campaigns"), function (req, res, ctx) {
        return res(ctx.delay(200), ctx.status(200), ctx.json([
            {
                id: "1",
                name: "Covid-19",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
            {
                id: "2",
                name: "Covid-19 Testing",
                deepLinkOnly: false,
                appointmentSettingType: "Test",
                additionalInfo: "Get tested for Covid-19",
                appointmentOptions: [
                    {
                        id: "100",
                        name: "Nasal Swab",
                        ordering: 1,
                    },
                    {
                        id: "201",
                        name: "Blood Draw",
                        ordering: 2,
                    },
                    {
                        id: "202",
                        name: "Something Else",
                        ordering: 3,
                    },
                    {
                        id: "203",
                        name: "Something Else 2",
                        ordering: 5,
                    },
                    {
                        id: "204",
                        name: "Something Else 3",
                        ordering: 4,
                    },
                ],
            },
            {
                id: "3",
                name: "Influenza",
                deepLinkOnly: true,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
            {
                id: "4",
                name: "Tetanus",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: [
                    { id: "401", name: "Shot", ordering: 1 },
                    { id: "402", name: "Pills", ordering: 2 },
                ],
            },
            {
                id: "5",
                name: "Disease 1",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
            {
                id: "6",
                name: "Disease 2",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
            {
                id: "7",
                name: "Disease 3",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
            {
                id: "8",
                name: "Disease 4",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
            {
                id: "9",
                name: "Disease 5",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
        ]));
    });
};
function getAvailableAppointmentCampaignsByDate(pharmacyId, startTime) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Appointment/AvailableCampaignsByDate",
        method: "GET",
        params: { pharmacyId: pharmacyId, startTime: startTime },
    })
        .then(function (response) {
        return response.data.filter(function (c) {
            return c.appointmentSettingType !== "Obsolete";
        });
    });
}
exports.getAvailableAppointmentCampaignsByDate = getAvailableAppointmentCampaignsByDate;
mock.getAvailableAppointmentCampaignsByDate = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Appointment/AvailableCampaignsByDate"), function (req, res, ctx) {
        return res(ctx.delay(200), ctx.status(200), ctx.json([
            {
                id: "50",
                name: "Additional Disease 1",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: null,
            },
            {
                id: "51",
                name: "Additional Disease 2",
                deepLinkOnly: false,
                appointmentSettingType: "Vaccination",
                additionalInfo: null,
                appointmentOptions: [
                    { id: "401", name: "Shot", ordering: 1 },
                    { id: "402", name: "Pills", ordering: 2 },
                ],
            },
        ]));
    });
};
function getAppointmentDates(pharmacyId, appointmentOptionId) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Appointment/AvailableDates",
        params: {
            AppointmentOptionId: appointmentOptionId,
            pharmacyId: pharmacyId,
        },
        method: "GET",
    })
        .then(function (response) { return response.data; });
}
exports.getAppointmentDates = getAppointmentDates;
mock.getAppointmentDates = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Appointment/AvailableDates"), function (req, res, ctx) {
        var appointmentOptionId = req.url.searchParams.get("AppointmentOptionId");
        return res(ctx.delay(1000), ctx.status(200), ctx.json({
            id: "1200",
            pharmacyId: 591,
            campaignOptionId: appointmentOptionId !== null && appointmentOptionId !== void 0 ? appointmentOptionId : "",
            duration: 100,
            expiresAfter: "2025-11-01T12:00:00",
            timeSlotsList: [
                {
                    startTime: "2025-11-07T08:00:00",
                    numAvailableSlots: 1,
                },
                {
                    startTime: "2025-11-14T08:30:00",
                    numAvailableSlots: 1,
                },
                {
                    startTime: "2025-11-21T09:00:00",
                    numAvailableSlots: 1,
                },
                {
                    startTime: "2025-11-31T09:30:00",
                    numAvailableSlots: 1,
                },
                {
                    startTime: "2025-12-07T08:30:00",
                    numAvailableSlots: 1,
                },
                {
                    startTime: "2025-12-14T08:30:00",
                    numAvailableSlots: 1,
                },
                {
                    startTime: "2025-12-21T08:30:00",
                    numAvailableSlots: 1,
                },
            ],
        }));
    });
};
function getAppointmentQuestions(_a) {
    var pharmacyId = _a.pharmacyId, appointmentOptionId = _a.appointmentOptionId, startTime = _a.startTime;
    return (0, instance_1.getInstance)()
        .request({
        url: "/Appointment/CampaignOptionQuestions",
        params: {
            AppointmentOptionId: appointmentOptionId,
            StartTime: startTime,
            pharmacyId: pharmacyId,
        },
        method: "GET",
    })
        .then(function (response) { return response.data; });
}
exports.getAppointmentQuestions = getAppointmentQuestions;
mock.getAppointmentQuestions = function () {
    return msw_1.rest.get("".concat((0, instance_1.getBaseURL)(), "/Appointment/CampaignOptionQuestions"), function (_, res, ctx) {
        return res(ctx.delay(1000), ctx.status(200), ctx.json({
            correlationId: "1201",
            resultQuestions: [
                {
                    questionText: "Do you choose yes or no?",
                    type: "YesOrNo",
                    sequenceNumber: 2,
                    choices: [
                        {
                            choice: "Yes",
                            sequenceNumber: 1,
                        },
                        {
                            choice: "No",
                            sequenceNumber: 2,
                        },
                    ],
                },
                {
                    questionText: "Write something nice",
                    type: "OpenText",
                    sequenceNumber: 1,
                    choices: null,
                },
                {
                    questionText: "Select your class",
                    type: "MultipleChoice",
                    sequenceNumber: 3,
                    choices: [
                        {
                            choice: "Rogue",
                            sequenceNumber: 2,
                        },
                        {
                            choice: "Barbarian",
                            sequenceNumber: 1,
                        },
                        {
                            choice: "Wizard",
                            sequenceNumber: 3,
                        },
                    ],
                },
                {
                    questionText: "Select your multiclass",
                    type: "MultipleChoice",
                    sequenceNumber: 4,
                    choices: [
                        {
                            choice: "Bard",
                            sequenceNumber: 1,
                        },
                        {
                            choice: "Sorcerer",
                            sequenceNumber: 2,
                        },
                        {
                            choice: "Fighter",
                            sequenceNumber: 3,
                        },
                        {
                            choice: "Paladin",
                            sequenceNumber: 4,
                        },
                        {
                            choice: "Cleric",
                            sequenceNumber: 5,
                        },
                    ],
                },
            ],
        }));
    });
};
function createAppointmentRequest(request) {
    var data = new FormData();
    if (typeof request.guestInsuranceCardFrontImage === "string" &&
        typeof request.guestInsuranceCardBackImage === "string") {
        data.append("guestInsuranceCardFrontImage", {
            name: request.guestInsuranceCardFrontImage,
            uri: request.guestInsuranceCardFrontImage,
            type: "image/jpeg",
        });
        data.append("guestInsuranceCardBackImage", {
            name: request.guestInsuranceCardBackImage,
            uri: request.guestInsuranceCardBackImage,
            type: "image/jpeg",
        });
    }
    else if (request.guestInsuranceCardFrontImage &&
        request.guestInsuranceCardBackImage) {
        data.append("guestInsuranceCardFrontImage", request.guestInsuranceCardFrontImage);
        data.append("guestInsuranceCardBackImage", request.guestInsuranceCardBackImage);
    }
    data.append("pharmacyId", request.pharmacyId.toString());
    data.append("correlationId", request.correlationId);
    data.append("campaignOptionId", request.campaignOptionId);
    data.append("startTime", request.startTime);
    if (request.patientId) {
        data.append("patientId", request.patientId);
    }
    if (request.guestFirstName) {
        data.append("guestFirstName", request.guestFirstName);
    }
    if (request.guestLastName) {
        data.append("guestLastName", request.guestLastName);
    }
    if (request.guestDOB) {
        data.append("guestDOB", request.guestDOB);
    }
    if (request.guestPhoneNum) {
        data.append("guestPhoneNum", request.guestPhoneNum);
    }
    if (request.guestEmail) {
        data.append("guestEmail", request.guestEmail);
    }
    if (request.guestStreetAddress) {
        data.append("guestStreetAddress", request.guestStreetAddress);
    }
    if (request.guestCity) {
        data.append("guestCity", request.guestCity);
    }
    if (request.guestState) {
        data.append("guestState", request.guestState);
    }
    if (request.guestZip) {
        data.append("guestZip", request.guestZip);
    }
    if (request.guestGender) {
        data.append("guestGender", request.guestGender.toString());
    }
    if (request.responses && request.responses.length > 0) {
        for (var i = 0; i < request.responses.length; i++) {
            data.append("responses[".concat(i, "].questionnumber"), request.responses[i].questionNumber.toString());
            data.append("responses[".concat(i, "].value"), request.responses[i].value);
        }
    }
    else {
        data.append("responses[0].questionNumber", "0");
        data.append("responses[0].value", "null");
    }
    return (0, instance_1.getInstance)()
        .request({
        url: "/Appointment",
        method: "POST",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
        .then(function (response) { return response.data; });
}
exports.createAppointmentRequest = createAppointmentRequest;
mock.createAppointmentRequest = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/Appointment"), function (_, res, ctx) {
        return res(ctx.delay(1000), ctx.status(200), ctx.text("Appointment was made"));
    });
};
function cancelAppointmentRequest(params) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/Appointment/Cancel",
        method: "POST",
        params: __assign({}, params),
    })
        .then(function (response) { return response.data; });
}
exports.cancelAppointmentRequest = cancelAppointmentRequest;
mock.cancelAppointmentRequest = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/Appointment/Cancel"), function (_, res, ctx) {
        return res(ctx.delay(1000), ctx.status(200));
    });
};
exports.appointmentHandlers = mock;
